import React from 'react';

const FollowUpTimer = ({
  className = '',
  fill = '#3b82f6',
  size = 200,
  ...props
}) => {
  return (
    <svg
      className={className}
      fill={fill}
      width={size}
      height={size}
      viewBox="0 0 296.228 296.228"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g>
        <path d="M167.364,48.003v-23.003h10.5c6.903,0,12.5-5.597,12.5-12.5s-5.596-12.5-12.5-12.5h-59.5c-6.903,0-12.5,5.597-12.5,12.5 s5.597,12.5,12.5,12.5h10.5v23.003c-59.738,9.285-105.604,61.071-105.604,123.37c0,68.845,56.01,124.854,124.854,124.854 s124.854-56.01,124.854-124.854C272.968,109.074,227.102,57.288,167.364,48.003z M148.114,271.228 c-55.06,0-99.854-44.795-99.854-99.854s44.795-99.854,99.854-99.854s99.854,44.795,99.854,99.854 S203.174,271.228,148.114,271.228z" />
        <path d="M160.614,166.18v-58.889c0-6.903-5.597-12.5-12.5-12.5s-12.5,5.597-12.5,12.5v66.1c0,2.033,0.81,3.982,2.25,5.416 l34.969,34.822c4.893,4.872,12.806,4.854,17.678-0.037c4.871-4.892,4.854-12.807-0.037-17.678L160.614,166.18z" />
      </g>
    </svg>
  );
};

export default FollowUpTimer;